/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_TRANSACTIONS,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_FAILURE,
  SAVE_TRANSACTIONS,
  SAVE_TRANSACTIONS_SUCCESS,
  SAVE_TRANSACTIONS_FAILURE,
  GET_TRANSACTIONS_FROM_BANK,
  GET_TRANSACTIONS_FROM_BANK_SUCCESS,
  GET_TRANSACTIONS_FROM_BANK_FAILURE,
  UPDATE_TRANSACTION,
  UPDATE_TRANSACTION_SUCCESS,
  UPDATE_TRANSACTION_FAILURE,
  DELETE_TRANSACTION,
  DELETE_TRANSACTION_SUCCESS,
  DELETE_TRANSACTION_FAILURE,
  DELETE_MULTI_TRANSACTION_SUCCESS,
  DELETE_MULTI_TRANSACTION_FAILURE,
  GET_OVERALL_CASHFLOW,
  GET_OVERALL_CASHFLOW_SUCCESS,
  GET_OVERALL_CASHFLOW_FAILURE,
  IMPORT_BANK_TRANSACTION,
  IMPORT_BANK_TRANSACTION_SUCCESS,
  IMPORT_BANK_TRANSACTION_FAILURE,
  RESET_TRANSACTIONS,
  GET_ALL_TRANSACTIONS,
  GET_ALL_TRANSACTIONS_SUCCESS,
  GET_ALL_TRANSACTIONS_FAILURE
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse
} from "./reducerUtils";

const initialState = {
  // transactions: [],
  bankTransactions: {
    data: [],
    state: "INIT",
    error: null
  },
  overallCashflow: {
    data: [],
    state: "INIT",
    error: null
  },
  transactions: {
    data: [],
    state: "INIT",
    error: null
  },
  bankTransactionImport: {
    data: [],
    state: "INIT",
    error: null
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_TRANSACTIONS:
      return setLoadingState(state, "transactions", "GET");

    case GET_TRANSACTIONS_SUCCESS:
      return setSuccessResponse(state, action, "transactions", "GET");

    case GET_TRANSACTIONS_FAILURE:
      return setErrorResponse(state, action.errResp, "transactions", "GET");

    case SAVE_TRANSACTIONS:
      return setLoadingState(state, "transactions", "SAVE");
    case SAVE_TRANSACTIONS_SUCCESS:
      return setSuccessResponse(state, action, "transactions", "SAVE");

    case SAVE_TRANSACTIONS_FAILURE:
      return setErrorResponse(state, action.errResp, "transactions", "SAVE");

    case GET_TRANSACTIONS_FROM_BANK:
      return setLoadingState(state, "bankTransactions");

    case GET_TRANSACTIONS_FROM_BANK_SUCCESS:
      return setSuccessResponse(state, action, "bankTransactions");
    case GET_TRANSACTIONS_FROM_BANK_FAILURE:
      return setErrorResponse(state, action.errResp, "bankTransactions");
    case UPDATE_TRANSACTION:
      return setLoadingState(state, "transactions", "UPDATE");

    case GET_ALL_TRANSACTIONS:
      return setLoadingState(state, "transactions", "GET_ALL");
    case GET_ALL_TRANSACTIONS_SUCCESS:
      return setSuccessResponse(state, action, "transactions", "GET_ALL");
    case GET_ALL_TRANSACTIONS_FAILURE:
      return setErrorResponse(state, action.errResp, "transactions", "GET_ALL");

    case UPDATE_TRANSACTION_SUCCESS:
      return setSuccessResponse(state, action, "transactions", "UPDATE");
    case UPDATE_TRANSACTION_FAILURE:
      return setErrorResponse(state, action.errResp, "transactions", "UPDATE");
    case DELETE_TRANSACTION:
      return setLoadingState(state, "transactions", "DELETE");

    case DELETE_TRANSACTION_SUCCESS:
      return setSuccessResponse(state, action, "transactions", "DELETE");
    case DELETE_TRANSACTION_FAILURE:
      return setErrorResponse(state, action.errResp, "transactions", "DELETE");
    case DELETE_MULTI_TRANSACTION_SUCCESS:
      for (let item of action.payload.data) {
        const delMultiItemIndex = state.transactions.findIndex(
          t => t._id === item._id
        );
        state.transactions.splice(delMultiItemIndex, 1);
      }

      return {
        isDeleteMultiTransactionSuccess: true,
        transactions: state.transactions,
        bankAccounts: state.bankAccounts
      };
    case DELETE_MULTI_TRANSACTION_FAILURE:
      return {
        isDeleteMultiTransactionSuccess: false,
        transactions: state.transactions,
        bankAccounts: state.bankAccounts
      };
    case GET_OVERALL_CASHFLOW:
      return setLoadingState(state, "overallCashflow");

    case GET_OVERALL_CASHFLOW_SUCCESS:
      return setSuccessResponse(state, action, "overallCashflow");

    case GET_OVERALL_CASHFLOW_FAILURE:
      return setErrorResponse(state, action.errResp, "overallCashflow");

    case IMPORT_BANK_TRANSACTION:
      return setLoadingState(state, "bankTransactionImport");

    case IMPORT_BANK_TRANSACTION_SUCCESS:
      return setSuccessResponse(state, action, "bankTransactionImport");

    case IMPORT_BANK_TRANSACTION_FAILURE:
      return setErrorResponse(state, action.errResp, "bankTransactionImport");

    case RESET_TRANSACTIONS:
      return setSuccessResponse(state, initialState);

    default:
      return state;
  }
}
